// @flow
import React from 'react';
import { useFormikContext } from 'formik';
import {
  CUSTOM_DISCOUNTS_JSON_BACKEND_NAME,
  METRICS_LEVEL_DISCOUNTS_CONFIG_ARRAY_BACKEND_NAME,
} from '@src/constants';
import { getIfAllMetricsAreFrozen } from '@components/custom-discounts/utils';
import { FieldArrayGrid, FieldArrayGridConfigItemContext } from '@src/formik-utils/FieldArrayGrid';
import { METRICS_LEVEL_DISCOUNTS_TOP_LEVEL_CONFIG_ARRAY_CONFIG } from '@src/configuration/custom-discounts';

import { CommitMetricsLevelDiscountsMetricConfigurationItem } from './CommitMetricsLevelDiscountsMetricConfigurationItem';

export const CommitMetricsLevelDiscountsTopLevelContainer = ({ readOnlyMode }) => {
  const { values: formikValues } = useFormikContext();
  const pathToFollowInValues = [
    CUSTOM_DISCOUNTS_JSON_BACKEND_NAME,
    METRICS_LEVEL_DISCOUNTS_CONFIG_ARRAY_BACKEND_NAME,
  ];

  const allMetricsAreFrozen = getIfAllMetricsAreFrozen(formikValues);

  return (
    <>
      <FieldArrayGrid
        addHeaders={false}
        addRowButtonDisabled={!allMetricsAreFrozen}
        columnsConfiguration={METRICS_LEVEL_DISCOUNTS_TOP_LEVEL_CONFIG_ARRAY_CONFIG}
        disabled={readOnlyMode}
        gridName="New Metric"
        pathToFollowInValues={pathToFollowInValues}
      >
        {(arrayHelpers, row, isCurrentlyBeingEdited, index, allRows, readOnlyMode) => (
          <FieldArrayGridConfigItemContext.Provider
            value={{
              allRows,
              arrayHelpers,
              columnsConfiguration: METRICS_LEVEL_DISCOUNTS_TOP_LEVEL_CONFIG_ARRAY_CONFIG,
              index,
              isCurrentlyBeingEdited,
              pathToFollowInValues: pathToFollowInValues,
              rowValues: row,
              readOnlyMode,
            }}
          >
            <CommitMetricsLevelDiscountsMetricConfigurationItem readOnlyMode={readOnlyMode} />
          </FieldArrayGridConfigItemContext.Provider>
        )}
      </FieldArrayGrid>
    </>
  );
};
